import about from './about/about';
import account from './account/account';
import article from './article/article';
import blog from './blog/blog';
import cart from './cart/cart';
import collection from './collection/collection';
import error from './error/error';
import funnel from './funnel/funnel';
import home from './home/home';
import kit from './kit/kit';
import login from './login/login';
import manifesto from './manifesto/manifesto';
import mlp from './mlp/mlp';
import page from './page/page';
import product from './product/product';
import recharge from './recharge/recharge';
import support from './support/support';

export {
  about,
  account,
  article,
  blog,
  cart,
  collection,
  error,
  funnel,
  home,
  kit,
  login,
  manifesto,
  mlp,
  page,
  product,
  recharge,
  support,
};
